const searchQueryKeys = {
  recentSearch: () => [
    "recent-search"
  ]
};

export { searchQueryKeys };
//# sourceMappingURL=searchQueryKeys.js.map
